import * as React from 'react';

import styled, { css } from 'styled-components';

import ButtonFixed from '@components/layout/button-fixed';
import Button, { ButtonProps } from '@components/actions/button';

import LoadingCtrl from '../loading';

interface ButtonLoadingFixedCtrlProps extends ButtonProps {
  smallest?: boolean;
  isLoading: boolean;
  success?: boolean;
  disableLoader?: boolean;
}

export const ButtonLoadingFixedCtrl: React.FC<ButtonLoadingFixedCtrlProps> = (
  props
) => {
  return (
    <ButtonFixed fixed>
      <Button {...props} disabled={props.disabled || props.isLoading}>
        {props.disableLoader ? null : (
          <LoadingCtrl
            size={props.smallest ? '60px' : undefined}
            className={`loading-animation ${
              props.isLoading ? 'is-loading' : ''
            }`}
            loading={props.isLoading}
          />
        )}

        {!props.isLoading ? props.children : null}
      </Button>
    </ButtonFixed>
  );
};

export default styled(ButtonLoadingFixedCtrl)`
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  ${(props) =>
    props.success
      ? css`
          background-color: ${({ theme }) => theme.colors.secondaryHover};

          span {
            svg {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        `
      : null}

  span {
    position: relative;
  }

  ${(props) =>
    props.small
      ? css`
          max-height: 48px !important;
          min-height: 48px !important;
        `
      : css`
          max-height: 48px;
          min-height: 48px;

          @media ${({ theme }) => theme.device.laptopL} {
            max-height: 60px;
            min-height: 60px;
          }
        `}

  .loading-animation {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0;
    transition: opacity
      ${({ theme }) =>
        `${theme.transitions.duration} ${theme.transitions.type}`};

    &.is-loading {
      opacity: 1;
    }

    svg {
      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }
`;
